/*
 * Copyright (c) 2019 Cédric Bodet.
 * The MIT License
 * http://www.opensource.org/licenses/mit-license
 */
import 'worldwindjs' //WorldWind global
import EnhancedWmsLayer from '../../globe/api/EnhancedWmsLayer'
import React from 'react'

/* global WorldWind */

export default class TampereNoisePolution extends EnhancedWmsLayer {
    constructor() {
        let cfg = {
            title: "Noise pollution",
            service: "https://geodata.tampere.fi/geoserver/wms?service=WMS",
            version: "1.3.0",
            layerNames: "ymparisto_ja_terveys:YV_MELU_P_2017_KESKIAANI",
        };

        super(cfg);

        this.urlBuilder.transparent = true;
    }

    doRender(dc) {
        super.doRender(dc);
        if (this.inCurrentFrame) {
            dc.screenCreditController.addCredit(
                " Open Data Tampere",
                WorldWind.Color.LIGHT_GRAY);
        }
    }

    getLayerDisplayInformation() {
        return (<div>
            <p>KUVAUS Mallinnetut meluvyöhykkeet kansallisilla tunnusluvulla laskettuna: Päiväaikainen keskiäänitaso
                LAeq 7-22 vuoden 2017 tilanne. Tiedon lähde on Tampereen kaupungin ympäristönsuojelulain mukainen
                meluselvitys 2017, joka laadittiin yhteistyössä Liikenneviraston kanssa. Melumallinnus sisältää
                laskennat pää- ja kokoojakatujen, suurimpien maanteiden- ja raideliikenteen, sekä Viinikan
                ratapiha-alueen aiheuttamasta melutasosta. Mallinnustieto ei sisällä mm. teollisuus- tai
                lentomelualueita. Mallinnus on tehty vuoden 2016 liikennetietoihin perustuen, melutaso on laskettu 2
                metrin korkeudelle maanpinnasta. Lisätiedot:
                https://www.tampere.fi/asuminen-ja-ymparisto/ymparisto-ja-luonto/julkaisut-ja-selvitykset/meluselvitys2017.html
            </p>
            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                <img
                    src={"https://geodata.tampere.fi/geoserver/ows?service=WMS&request=GetLegendGraphic&format=image%2Fpng&width=20&height=20&layer=ymparisto_ja_terveys%3AYV_MELU_P_2017_KESKIAANI"}
                    alt={"Legend"}/>
            </div>
            <p style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }}>
                Legend
            </p>
        </div>);
    }
}
